import { RootState } from '@/store/store';
import { runWithHeap } from '@/analytics/heapAnalytics';
import { User } from '@/models/User';

import * as React from 'react';
import { connect } from 'react-redux';

type TrackUserProps = {
  currentUser: User | null;
};

export const TrackUserComp = ({ currentUser }: TrackUserProps) => {
  React.useEffect(() => {
    const userUUID = currentUser?.uuid ?? null;
    runWithHeap((heap) => {
      heap.addEventProperties({ 'nora.userUUID': userUUID });
    });
  }, [currentUser]);
  return null;
};

const mapStateToProps = (state: RootState): TrackUserProps => {
  return {
    currentUser: state.userStore.currentUser,
  };
};

export const TrackUser = connect(mapStateToProps)(TrackUserComp);
